"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = CheckmarkSmall;

var _CheckmarkSmall = require("@adobe/react-spectrum-ui/dist/CheckmarkSmall.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function CheckmarkSmall(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_CheckmarkSmall.CheckmarkSmall, null));
}